/**
 * @file: 双击
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent } from '../../message/index';
import * as CubeTree from '../../cubeTree/index';

function show(ev: Event): void {
    let $target: JQuery<EventTarget> = $(ev.target);
    let $cubeEl: JQuery<EventTarget> = $target.closest('[data-instanceid]');

    if (!$cubeEl.length) {
        return;
    }

    let cubeId: string = $cubeEl.attr('data-instanceid');

    if (CubeTree.isCabinet(cubeId)) {
        cubeId = CubeTree.findParentIdByCubeId(cubeId);
    }

    let clickCube: CubeNode = CubeTree.findByCubeId(cubeId);

    StageEvent.fire('showModal', {
        eventFrom: 'stage',
        cubes: [clickCube]
    });
}

export default {
    show
};
